import {
    INIT_FLUID_HANDLER_LIST_REQUEST,
    SET_FLUID_HANDLER_LIST,
    ERROR_FLUID_HANDLER_LIST,
    INIT_SINGLE_FLUID_HANDLER_REQUEST,
    SET_SINGLE_FLUID_HANDLER,
    ERROR_SINGLE_FLUID_HANDLER
} from './action';

const initialState = {
    isLoading: false,
    fluidHandlerList: [],
    singleFluidHandler: null,
    singleFluidHandlerLoading: false,
    singleFluidHandlerError: null,
    error: null
};

const fluidHandlerReducer = (state = initialState, action) => {
    switch (action.type) {
        case INIT_FLUID_HANDLER_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case SET_FLUID_HANDLER_LIST:
            return {
                ...state,
                isLoading: false,
                fluidHandlerList: action.payload,
                error: null
            };
        case ERROR_FLUID_HANDLER_LIST:
            return {
                ...state,
                isLoading: false,
                fluidHandlerList: [],
                error: action.payload
            };
        case INIT_SINGLE_FLUID_HANDLER_REQUEST:
            return {
                ...state,
                singleFluidHandlerLoading: true,
                singleFluidHandlerError: null,
                singleFluidHandler: null
            };
        case SET_SINGLE_FLUID_HANDLER:
            return {
                ...state,
                singleFluidHandlerLoading: false,
                singleFluidHandler: action.payload,
                singleFluidHandlerError: null
            };
        case ERROR_SINGLE_FLUID_HANDLER:
            return {
                ...state,
                singleFluidHandlerLoading: false,
                singleFluidHandler: null,
                singleFluidHandlerError: action.payload
            };
        default:
            return state;
    }
};

export default fluidHandlerReducer;
